module.exports = "/* define color */\n/* define color */\n/* define color */\n/* define color */\n/* define color */\n"